import React from 'react'

const SkeletonManagementNavBar = () => {
    return (
        <div className="managements-lists-nav flex flex-row flex-wrap xl:flex-nowrap gap-y-[10px] animate-pulse">
            <div className="flex flex-row items-center flex-1 gap-[30px]">
                <div className="h-[39px] w-[277px] bg-lightBG rounded" />
                <div className="h-[39px] w-[318px] bg-lightBG rounded" />
            </div>
            <div className="flex flex-row items-center gap-4 flex-1 justify-end">
                <div className="flex flex-row items-center   bg-lightBG w-[288px] h-[41px] rounded-full gap-2"></div>
                <div className="h-[56px] w-[190px] bg-lightBG rounded-full" />
            </div>
        </div>
    )
}

export default SkeletonManagementNavBar
